// extracted by mini-css-extract-plugin
module.exports = {"Card":"timer_Card__2_Uxu","Cardtimer":"timer_Cardtimer__38iMK","items":"timer_items__3EDDZ"};